const arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
export const skyBgData = arr.map(i=>({ url: `/images/stage/skybox/${i}.jpg` }));

export const skyRect = { w: 127 * 2 * 20, h: 1170 * 2 * 0.6 };



// WEBPACK FOOTER //
// ./src/stage/scene/skybox/config.js